import store from "../store";
const dics = [
  {
    title: "filter",
    az: "İstediğini ara",
    en: "Find what you need",
    ru: "Найдите что желаете",
  },
  {
    title: "ingrad",
    az: "İçeriği göster",
    en: "Show ingradients",
    ru: "Инградиенты",
  },
  { title: "showall", az: "Tümü", en: "Show all", ru: "Показать все" },
  { title: "search", az: "Ara", en: "Search", ru: "Поиск" },
  { title: "found", az: "Bulunan", en: "Found", ru: "Найдено" },
  { title: "searchresult", az: "Arama sonuçları", en: "Search result", ru: "Результат поиска" },
  { title: "or", az: "Ve ya", en: "Or", ru: "Или" },
  { title: "selectcat", az: "Menüden seçin", en: "Select from the menu below", ru: "Выбкрите из меню ниже" },
  { title: "tobasket", az: "Sepete ekle", en: "Add to cart", ru: "Добавить в карзину" },
  { title: "gotobasket", az: "Sepete geç", en: "To cart", ru: "Перейти в карзину" },
  { title: "name", az: "Adı", en: "Name", ru: "Название" },
  { title: "price", az: "Fiyat", en: "Price", ru: "Цена" },
  { title: "total", az: "Son", en: "Total", ru: "Итого" },
  { title: "count", az: "Say", en: "Count", ru: "Кол-во" },
  { title: "amount", az: "Miktar", en: "Sum", ru: "Сумма" },
  { title: "continueshop", az: "Menüye geri dön", en: "Back to menu", ru: "Вернуться к меню" },
  { title: "shopcart", az: "Sepet", en: "Shopping Cart", ru: "Корзина" },
  { title: "finish", az: "Siparişi tamamla", en: "Complete Purchase", ru: "Завершить покупку" },
  { title: "customername", az: "Müşteri adı", en: "Cusotmer name", ru: "ФИО" },
  { title: "phone", az: "Telefon", en: "Phone", ru: "Телефон" },
  { title: "email", az: "Email", en: "Email", ru: "Email" },
  { title: "payonline", az: "Online", en: "Online", ru: "Online" },
  { title: "paycash", az: "Nakit ödeme", en: "By cash", ru: "Наличными" },
  { title: "paybycard", az: "POS terminal", en: "By credit card (POS terminal)", ru: "По карте через терминал" },
  { title: "personalinfo", az: "Kişisel bilgi", en: "Personal information", ru: "Личная информация" },
  { title: "paytype", az: "Ödeme türü", en: "Payment method", ru: "Способ оплаты" },
  { title: "change", az: "Kalıntı talep edilen tutar (₼ 1-1000)", en: "Change for (₼ 1-1000)", ru: "Сдачи от (₼ 1-1000)" },
  { title: "deliverytype", az: "Teslimat türü", en: "Delivery method", ru: "Способ доставки" },
  { title: "dlvrcourier", az: "Kurye", en: "Courier", ru: "Курьер" },
  { title: "dlvrpickup", az: "Kişisel ulaşım", en: "Pick up yourself", ru: "Самовывоз" },
  { title: "dlvrimhere", az: "Restorandayım", en: "I'm here", ru: "Я в ресторане" },
  { title: "deliverytime", az: "Teslimat süresi", en: "Delivery time", ru: "Время доставки" },
  { title: "now", az: "Şimdi", en: "ASAP", ru: "Сейчас" },
  { title: "later", az: "Daha sonra", en: "Later", ru: "Позже" },
  { title: "street", az: "Sokak", en: "Street", ru: "Улица" },
  { title: "entrance", az: "Giriş/Apartman", en: "Entrance", ru: "Вход/блок" },
  { title: "entrancecode", az: "Giriş kodu", en: "Entrance code", ru: "Код домофона" },
  { title: "house", az: "Ev", en: "House", ru: "Дом" },
  { title: "floor", az: "Kat", en: "Floor", ru: "Этаж" },
  { title: "flatoffice", az: "Apartman/Site/Ofis", en: "Flat/Office", ru: "Квартира/Офис" },
  { title: "addressnote", az: "Adres kaydı", en: "Note to address", ru: "Примечание к адресу" },
  { title: "tablenumber", az: "Masa numarası", en: "Table number", ru: "Номер стола" },
  { title: "totalorderprice", az: "İndirim ve teslimat dahil fiyat", en: "Price including discount and delivery", ru: "Цена с учетом скидки и доставки" },
  { title: "backtocart", az: "Sepete geri dön", en: "Back to cart", ru: "Вернуться в карзину" },
  { title: "finishorder", az: "Siparişi tamamla", en: "Place your order", ru: "Оформить заказ" },
  { title: "ordering", az: "Siparişin tamamlanması", en: "Ordering", ru: "Оформление заказа" },
  { title: "fillrequireds", az: "Gerekli alanları doldurun", en: "Fill required fields", ru: "Заполните обязательные поля" },
  { title: "select", az: "Seçin", en: "Select", ru: "Выберите" },
  { title: "ordernumber", az: "Sipariş numarası", en: "Order number", ru: "Номер заказа" },
  { title: "ordersent", az: "Sipariş gönderildi", en: "Order sent", ru: "Заказ отправлен" },
  { title: "close", az: "Kapat", en: "Close", ru: "Закрыть" },
  { title: "cartempty", az: "Sepetiniz boş", en: "Your cart is empty", ru: "Ваша корзина пуста" },
  { title: "example", az: "Örnek", en: "Example", ru: "Пример" },
  { title: "showonmap", az: "Haritada göster", en: "Show on map", ru: "Показать на карте" },
  { title: "selectedloc", az: "Seçilen konum", en: "Selected location", ru: "Выбранное место" },
  { title: "wtime", az: "İş vaktı", en: "Working hours", ru: "Рабочее время" },
  { title: "available", az: "Mevcuttur", en: "Available", ru: "Доступно" },
  { title: "pax", az: "Kişi", en: "Pax", ru: "Кол-во персон" },
  { title: "ordernow", az: "Sipariş", en: "Order", ru: "Заказ" },
  { title: "menu", az: "Menü", en: "Menu", ru: "Меню" },
  { title: "cat", az: "Kategori", en: "Category", ru: "Категория" },
  { title: "reqtablepax", az: "Masa numarası ve Kişi alanları gereklidir", en: "Table number and Pax fields are required", ru: "Поля Номер стола и Кол-во персон обязательны" },
];
export default {
  localeText(text) {
    let item = dics.filter((c) => c.title === text);
    if (item.length === 0) return "Label not found";
    switch (store.state.lang) {
      case "AZ":
        return item[0].az;
      case "EN":
        return item[0].en;
      case "RU":
        return item[0].ru;
    }
  },
};
